import * as styles from "./Header.module.css";
import returnsWealthLogo from "../../assets/images/returns-wealth-logo.png";

const Header = () => {
  return (
    <>
      <div className={styles.logoParent}>
        <img src={returnsWealthLogo} alt="Returns" className={styles.returnsWealthLogo} />
      </div>
    </>
  );
};

export default Header;
